import React, { useEffect, useState } from "react";
import DashboardLayout from "../../layoutcontainers/DashboardLayout";
import { Card, CardHeader, ListItemIcon, Stack } from "@mui/material";
import MaterialTypography from "../../components/MaterialTypography";
import MaterialButton from "../../components/MaterialButton";
import MaterialDataGrid from "../../components/MaterialDataGrid";
import AddIcon from "@mui/icons-material/Add";
import { useNavigate } from "react-router-dom";
import request, { gql } from "graphql-request";
import { GridActionsCellItem } from "@mui/x-data-grid";
import BASEURL from "../Utils/Baseurl";
import { DeleteUomMutation } from "../../lib/graphQL/graphMutation";
import { AllBrandDetailsQuery } from "../../lib/graphQL/graphQuery";
import { useAuth } from "../../context/AuthContext/AuthContextProvider";
import URL from "../Utils/url";
import { useLoading } from "../../context/LodingContext";
import PageLoading from "../../components/Loading/PageLoading";
import TableComponent from "../../components/GridTable/TableComponent";

export default function BrandListTable() {
  const { currentUser } = useAuth();
  const navigate = useNavigate();
  const [brandData, setBrandData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [id, setId] = useState("");
  const [status, setStatus] = useState(false);

  const [pageState, setPageState] = useState({
    loading: false,
    error: false,
    message: "",
    state: "init",
  });

  //useEffect to Fetch Data
  useEffect(() => {
    fetchBrandData();
    setStatus(false);
  }, [id, status]);

  //Fetch Table Data
  const fetchBrandData = () => {
      setIsLoading(true);
      request(BASEURL, AllBrandDetailsQuery, { id: currentUser?.id })
        .then((res) => {
          setBrandData(res.allBrandDetail);
        })
        .finally(() => {
          setIsLoading(false);
        });
  };

  //Table Mapping
  const brandListTable = {
    columns: [
      {
        label: "S.No",
        field: "sno",
        name: "S.NO",
        width: 100,
        disableColumnMenu: true,
        editable: false,
      },
      {
        label: "Brand ID",
        field: "brandid",
        name: "Brand ID",
        width: 150,
        disableColumnMenu: true,
        editable: false,
      },

      {
        label: "Brand Logo",
        field: "brandLogo",
        name: "Brand Logo",
        flex: 1,
        editable: false,
        disableColumnMenu: true,
        // type: "images",
      },
      {
        label: "Brand Name",
        field: "brandName",
        name: "Base Unit",
        flex: 1,
        editable: false,
        disableColumnMenu: true,
      },
      {
        label: "Brand Industry",
        field: "brandIndustry",
        name: "Brand Industry",
        flex: 1,
        editable: false,
        disableColumnMenu: true,
      },
      {
        label: "Created By",
        field: "createdBy",
        name: "Created By",
        flex: 1,
        editable: false,
        disableColumnMenu: true,
      },
      {
        label: "Created At",
        field: "createdAt",
        name: "Created At",
        flex: 1,
        editable: false,
        disableColumnMenu: true,
      },
    ],
    rows: brandData.reverse().map((item, index) => ({
      sno: index + 1,
      brandid: item.brandid,
      id: item.id,
      // brandLogo:`${URL}"media/"${item.brandLogo.replace(" ", "%20")}`,
      brandLogo: (
        <img
          src={URL + "media/" + item.brandLogo.replace(" ", "%20")}
          style={{ width: "60px", height: "50px", objectFit: "contain" }}
        />
      ),
      brandName: item.brandName,
      brandIndustry: item.brandIndustry,
      createdBy: item.user.username,
      createdAt: item.createdAt ? item.createdAt.slice(0, 10) : "N/A",
    })),
  };

  //Add Brand Button Handle
  const handleNewBrand = () => {
    navigate("/brand/add-brand");
  };

  //Handle Row Click
  const onBrandListClick = (e) => {
    if (e?.id) {
      navigate(`/brand/add-brand?${e?.id}`);
    }
  };

  const onCheck=(list)=>
  {
      console.log("id-c",list)
  }
  const onDelete=(id)=>
  {
      console.log("id-d",id)
  }
  const onDeleteALL=()=>
  {
      console.log("id-DELE")
  }

  return (
    <DashboardLayout
    tableData={brandListTable}>
      <TableComponent
      tableLoading={isLoading ? true : false}
      columns={brandListTable.columns}
      rowsData={brandListTable.rows}
      head="Brand List"
      actions={true}
      checked={false}
      view={true}
      showAdd = {true}
      onCheck={onCheck}
      onEdit={onBrandListClick}
      onDelete={onDelete}
      onView={onBrandListClick}
      onDeleteALL={onDeleteALL}
      addList={() => handleNewBrand()}
      />
      {/* <Card>
        <CardHeader
          title={
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              spacing={2}
            >
              <Stack direction="column" spacing={0}>
                <MaterialTypography variant="h5" fontWeight="medium">
                  Brand List
                </MaterialTypography>
              </Stack>

              <MaterialButton
                variant="gradient"
                color="dark"
                size="small"
                startIcon={<AddIcon />}
                onClick={() => handleNewBrand()}
              >
               Add Brand
              </MaterialButton>
            </Stack>
          }
        />
        {!isLoading && (
          <MaterialDataGrid
            rows={brandListTable.rows}
            columns={brandListTable.columns}
            isSelectable={false}
            onRowClick={onBrandListClick}
            loading={pageState.loading}
            localeText={{
              noRowsLabel: (
                <Stack
                  direction="column"
                  alignItems="center"
                  justifyContent="center"
                  spacing={1}
                >
                  <MaterialTypography
                    variant="body2"
                    fontWeight="medium"
                    color="text"
                  >
                    No Brands are found
                  </MaterialTypography>
                  <MaterialTypography variant="caption" color="text">
                    You have not yet added any Brand details. Click on the "Add
                    Brand" button to start adding Brand details.
                  </MaterialTypography>
                </Stack>
              ),
            }}
          />
        )}
        {isLoading && <PageLoading />}
      </Card> */}
    </DashboardLayout>
  );
}
